import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ChooseBranchComponent } from "./main-section/choose-branch/choose-branch.component"
import { ChoosePrinterComponent } from "./main-section/choose-printer/choose-printer.component"
import { SocialComponent } from "./auth/social/social.component";

import { AuthGuard } from "./auth/auth.guard";
import { TAndCComponent } from "./main-section/legal/t-and-c/t-and-c.component"
import { PrivacyPolicyComponent } from "./main-section/legal/privacy-policy/privacy-policy.component"
import { ReceiptViewComponent } from "./other-pages/receipt-view/receipt-view.component"

import { BranchListComponent } from "./super-management/branch/branch-list/branch-list.component";
import { BranchCreateComponent } from "./super-management/branch/branch-create/branch-create.component";
import { PrintingTableComponent } from "./main-section/printing-table/printing-table.component";
import { QrLinkComponent } from "./main-section/qr-link/qr-link.component";

import { ProductListComponent } from "./super-management/product/product-list/product-list.component";
import { ProductCreateComponent } from "./super-management/product/product-create/product-create.component";

import { MyOrdersComponent } from "./other-pages/my-orders/my-orders.component";
import { HomeComponent } from "./other-pages/home/home.component";
import { MyProfileComponent } from "./other-pages/my-profile/my-profile.component";
import { PrintingQueComponent } from "./other-pages/printing-que/printing-que.component";
import { QAndAComponent } from "./other-pages/q-and-a/q-and-a.component";
import { PendingOrderComponent } from "./other-pages/pending-order/pending-order.component";
import { HelpersComponent } from "./other-pages/helpers/helpers.component";

import { UserListComponent } from "./super-management/user/user-list/user-list.component";
import { UserEditComponent } from "./super-management/user/user-edit/user-edit.component";
import { PaperListComponent } from "./super-management/paper/paper-list/paper-list.component";
import { PaperCreateComponent } from "./super-management/paper/paper-create/paper-create.component";
import { StationScreenComponent } from "./super-management/station-screen/station-screen.component";

import { EditInstructionsComponent } from "./other-pages/edit-instructions/edit-instructions.component";
import { PersonalWallComponent } from "./wall/personal-wall/personal-wall.component";
import { EazixExhibitionComponent } from "./wall/eazix-exhibition/eazix-exhibition.component";
const routes: Routes = [
    // /en – אנגלית + בחירת סניף (כמו /, לא Home). לפני path: "" — pathMatch: 'full' מונע בלבול
    { path: "en", pathMatch: "full", component: ChooseBranchComponent, data: { homeLang: "en" } },

    { path: "", pathMatch: "full", component: ChooseBranchComponent },

    { path: "branch", component: ChoosePrinterComponent },
    { path: "branch/:branchName", component: ChoosePrinterComponent },
    {
      path: "3dproduct",
      loadChildren: () =>
        import("./ph-lazy/ph-product-entry.module").then((m) => m.PhProductEntryModule),
    },
    {
      path: "phproduct",
      loadChildren: () =>
        import("./ph-lazy/ph-product-entry.module").then((m) => m.PhProductEntryModule),
    },
    { path: "product", redirectTo: "/3dproduct", pathMatch: "full" },
    { path: "print", component: PrintingTableComponent },
    {
      path: "phprint",
      loadChildren: () =>
        import("./ph-lazy/ph-print-entry.module").then((m) => m.PhPrintEntryModule),
    },

    { path: "home", component: HomeComponent },
    { path: "home/:lang", component: HomeComponent },
    { path: "joinus", component: HomeComponent },
    { path: "joinus/:lang", component: HomeComponent },
    { path: "myorders/:userId", component: MyOrdersComponent },
    { path: "userorders/:userId/:orderId", component: MyOrdersComponent },
    { path: "userorders/:userId", component: MyOrdersComponent },
    { path: "myprofile/:userId", component: MyProfileComponent },
    { path: "queue/:branch", component: PrintingQueComponent },
    { path: "myprofile/:userId/credit", component: MyProfileComponent },
    { path: "qanda/:id", component: QAndAComponent },
    { path: "qanda", component: QAndAComponent },
    { path: "x/:service/:orderId", component: PendingOrderComponent },
    { path: "helpers", component: HelpersComponent },
    { path: "support", component: HelpersComponent },
    { path: "remove", component: HelpersComponent },
    { path: "tandc", component: TAndCComponent },
    { path: "terms", component: TAndCComponent },
    { path: "pp", component: PrivacyPolicyComponent },
    { path: "privacy", component: PrivacyPolicyComponent },
    { path: "r/:token", component: ReceiptViewComponent },
    { path: "qr/:service/:branch", component: QrLinkComponent },
    { path: "qr/:service/:branch/new", component: QrLinkComponent },

    { path: "social", component: SocialComponent },

    { path: "branchlist", component: BranchListComponent },
    { path: "branchcreate", component: BranchCreateComponent },
    { path: "branchedit/:branchId", component: BranchCreateComponent },

    { path: "productlist", component: ProductListComponent },
    { path: "productcreate", component: ProductCreateComponent },
    { path: "productedit/:productId", component: ProductCreateComponent },

    { path: "userlist", component: UserListComponent },
    { path: "useredit/:userId", component: UserEditComponent },

    { path: "paperlist", component: PaperListComponent },
    { path: "papercreate", component: PaperCreateComponent },
    { path: "paperedit/:paperId", component: PaperCreateComponent },

    { path: "screen/:service/:branch", component: StationScreenComponent },
    { path: "screen", component: StationScreenComponent },

    {
      path: "printer",
      loadChildren: () =>
        import("./management-lazy/management-printer-entry.module").then(
          (m) => m.ManagementPrinterEntryModule
        ),
    },
    {
      path: "monitor",
      loadChildren: () =>
        import("./management-lazy/management-monitor-entry.module").then(
          (m) => m.ManagementMonitorEntryModule
        ),
    },
    {
      path: "business",
      loadChildren: () =>
        import("./management-lazy/management-business-entry.module").then(
          (m) => m.ManagementBusinessEntryModule
        ),
    },
    {
      path: "express-internal-queue",
      loadChildren: () =>
        import("./management-lazy/management-express-internal-queue-entry.module").then(
          (m) => m.ManagementExpressInternalQueueEntryModule
        ),
    },
    { path: "edit", component: EditInstructionsComponent },
    { path: "wall", component: PersonalWallComponent, canActivate: [AuthGuard] },
    { path: "exhibition", component: EazixExhibitionComponent },
    { path: "exhibition/:userId", component: EazixExhibitionComponent },
    {
      path: "chat",
      loadChildren: () =>
        import("./ph-lazy/ph-chat-entry.module").then((m) => m.PhChatEntryModule),
    },

    // errors:
    { path: '**', redirectTo: '/' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [AuthGuard]
})
export class AppRoutingModule { }
